;(function () {
  angular
    .module('contrast.typography')
    .directive('csVariableFont', function () {
      var maxFontSize = 200,
        parsedFloat = 0,
        maxWidth = 0,
        element = null

      return {
        restrict: 'A',
        scope: {
          csVariableFont: '=',
          maxFontSize: '='
        },
        link: link
      }

      function link(scope, elem) {
        element = elem
        parsedFloat = parseFloat(scope.maxFontSize)
        maxWidth = elem[0].clientWidth

        scope.$watch('csVariableFont', function (newVal, oldVal) {
          if (newVal.length > 0 && newVal != oldVal) {
            setFontSize(newVal)
          }
        })

        if (scope.csVariableFont.length > 0) {
          setFontSize(scope.csVariableFont)
        }
      }

      function setFontSize(content) {
        if (maxWidth > 0) {
          var fontSize = maxFontSize

          if (parsedFloat && parsedFloat > 0 && parsedFloat < 200) {
            maxFontSize = parsedFloat
          }

          element.css('visibility', 'hidden')
          element.css('font-size', maxFontSize + 'px')
          element.text(content)

          while (element[0].scrollWidth > maxWidth && fontSize > 0) {
            element.css('font-size', fontSize + 'px')
            fontSize--
          }

          element.css('visibility', '')
        }
      }
    })
})()
